import { AlertTriangle } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

const AgeGate = ({ onVerify }) => {
  const { isDark } = useTheme();
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 backdrop-blur-md" data-testid="age-gate">
      <div className={`max-w-md mx-4 p-8 ${isDark ? 'bg-[#111] border-red-900/50' : 'bg-white border-gray-300'} border rounded-lg text-center`}>
        <AlertTriangle size={48} className="mx-auto mb-4 text-red-500" />
        <h2 className="font-cinzel text-2xl font-bold mb-2">Mature Content Warning</h2>
        <div className="inline-block px-3 py-1 bg-red-600 text-white text-xs font-bold tracking-wider rounded mb-4">17+</div>
        <p className={`text-sm mb-6 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          <strong>Signed, Sealed, Betrayed</strong> contains explicit content including graphic scenes, strong language, violence, and adult themes. This content is intended for readers aged 17 and older.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => onVerify(true)}
            className="w-full py-3 bg-red-600 hover:bg-red-700 text-white font-bold tracking-wider transition-colors rounded"
            data-testid="age-gate-confirm"
          >
            I AM 17 OR OLDER
          </button>
          <button
            onClick={() => onVerify(false)}
            className={`w-full py-3 ${isDark ? 'bg-white/10 hover:bg-white/15 text-gray-300' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'} font-semibold transition-colors rounded`}
            data-testid="age-gate-decline"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
